module.exports = __webpack_public_path__ + "img/in-header.98891bdc.png";